import 'dayjs/locale/fr';

import dayjs, { Dayjs } from 'dayjs';
import _isToday from 'dayjs/plugin/isToday';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.locale('fr');
dayjs.extend(relativeTime);
dayjs.extend(_isToday);

export const formatDelay = (createdAt: string): string => {
  const now = dayjs();
  const elapsedTime = now.diff(dayjs(createdAt), 'h', true);
  const minElapsedTime = 1;
  if (elapsedTime <= minElapsedTime) {
    return dayjs(createdAt).fromNow();
  }
  return dayjs(createdAt).format('DD MMMM YYYY');
};

export const timeFromDate = (date: Dayjs) => {
  if (date.isToday()) {
    return date.fromNow(true);
  }

  return date.format('DD MMM').toLowerCase();
};

export const isToday = (date: Dayjs) => date.isToday();
